import React from 'react';
import { WhisperComponent } from '../developers/page-components/WhisperComponent';
import { toAbsoluteUrl } from '../../utils';
import { IAgency } from '../../constants/new-agency/new-agency-form';
import { useNavigate, useLocation } from 'react-router-dom';
import clsx from 'clsx';

interface Props extends IAgency {
	onEdit?: (agent?: IAgency) => void;
	isAgencyPage?: boolean;
}

export const AgencyTableRow = (props: Props): React.ReactElement => {
	const { onEdit, isAgencyPage, ...agency } = props;
	const { name, id } = agency;
	const navigate = useNavigate();
	const { pathname } = useLocation();
	return (
		<tr>
			<td>
				<div
					className={clsx('fs-6', isAgencyPage && 'cursor-pointer')}
					onClick={(): void => isAgencyPage && navigate(`${pathname}/${id}`)}
				>
					{name}
				</div>
			</td>
			{
				!isAgencyPage && (
					<td
						className={clsx('fs-6', isAgencyPage && 'cursor-pointer')}
						onClick={(): void => isAgencyPage && navigate(`${pathname}/${id}`)}
					>
						<WhisperComponent
							whisperText={id}
							mainText={id}
							placement="bottomStart"
							additionalClass="d-block fw-bolder fs-6 text-truncate w-100 mt-2"
						/>
					</td>
				)
			}
			<td>
				<div
					className="d-flex align-items-center cursor-pointer"
					onClick={(): void => onEdit(agency)}
				>
					<img
						src={toAbsoluteUrl('/media/icons/edit-icon.svg')}
						height={16}
						width={16}
						alt="edit-icon"
					/>
					<span className="text-muted fs-7 fw-bolder ms-2" style={{ lineHeight: '20px' }}>
										Edit
									</span>
				</div>
			</td>
		</tr>
	);
};
